import { useTopic } from 'hooks/useTopic';
import Heading from 'components/universal/heading';
import { useTranslation } from 'react-i18next';
import { Overview } from 'views/online-trainings/hand-hygiene/overview';
import cls from './course-list.module.scss';

export const CourseList = () => {
    const { t } = useTranslation('', { keyPrefix: 'onlineTrainings' });
    const { continueCourse, allCoursesData } = useTopic();
    
    return (
        <div className={cls.container}>
            <Heading headingLevel="h1" className={cls.title}>
                {t('title')}
            </Heading>
            {allCoursesData && allCoursesData.length > 0 ? (
                <section className={cls.coursesList}> 
                    {allCoursesData.map((course) => (
                        <div className={cls.coursesItem} key={course.id}>
                            <Overview courseData={course} continueCourse={continueCourse} type="list" />
                        </div>
                    ))}
                </section>
            ) : (
                <p>{t('noCourses')}</p>
            )}

        </div>
    );
};
